import * as R from 'ramda'
import P from 'helpers/predicates'

const riskEq = R.propEq('risk')

const isRisk = [
  [R.or(riskEq('Allowed'), riskEq(null)), 'Value is a risk.'],
]

export {
  isRisk,
}
